export default "src/content/themes/association-wordpress-theme/img/a9e238168b022d3301388266a71b0b1c.png";